// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(Backend) // Use backend to load translations
  .use(LanguageDetector) // Use language detector to detect user language
  .use(initReactI18next) // Integrate with React
  .init({
    fallbackLng: "en", // Use English as fallback language
    debug: true, // Enable debug for development
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense for translations
    },
    resources: {
      en: {
        translation: require("./locales/en/translation.json"),
      },
      gu: {
        translation: require("./locales/gu/translation.json"),
      },
      hi: {
        translation: require("./locales/hi/translation.json"),
      },
    },
    // You can configure the path to translation files (if using Backend)
    // backend: {
    //   loadPath: '/locales/{{lng}}/{{ns}}.json'
    // },
  });

export default i18n;
